<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="产品详情"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="14">
        <div class="border-style">基本信息</div>
        <el-form :model="item" ref="itemform" label-width="120px">
          <el-form-item label="产品型号名称">
            <el-input
              v-if="item.DciProductModel"
              v-model.trim="item.DciProductModel.Name"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="产品型号">
            <el-input
              v-if="item.DciProductModel"
              v-model.trim="item.DciProductModel.Number"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="产品SN">
            <el-input v-model.trim="item.SN" disabled></el-input>
          </el-form-item>
          <el-form-item label="入库日期">
            <el-date-picker
              v-model="item.StockinAt"
              style="width: 100%"
              type="date"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="10">
        <div class="dialogDiv">
        <div class="border-style">日志信息</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="
                $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
              "
              placement="top"
            >
              <el-card>
                <p style="margin-top: 0px; margin-bottom: 0px">
                  {{ activity.Content }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      activities: [],
      item: _.clone(this.value),
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.getLog();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    getLog() {
      this.$axios
        .get(`dci/product/${this.item.ID}/record`, {
          params: {
            ...this.pager,
            order: ["-updated_at","-id"],
          },
        })
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>

<style scoped>
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.dialogDiv {
  height: 300px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
